import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { PrimeTemplate } from "primeng-v17/api";
import { FieldsetModule } from "primeng-v17/fieldset";
import { InputTextModule } from "primeng-v17/inputtext";
import { CandidateDocumentDateComponent } from "../../features/candidate-document-metadata/metadata-wrapper-components/candidate-document-date.component";
import { EnumPipe } from "../../shared/pipes/enum.pipe";
import { StaticDataPipe } from "../../shared/static-data/static-data.pipe";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiFormlyCertifiedEducationExamsEntryComponent } from "./new-ui-formly-certified-education-exams-entry.component";
import { AppDatePipe } from "../../shared/pipes/date.pipe";
import { DatepickerComponent } from "../../shared/form/datepicker/datepicker.component";

@Component({
  selector: "app-formly-certified-education-exams-entry",
  templateUrl: "./formly-certified-education-exams-entry.component.html",
  imports: [
    TranslateDirective,
    NgIf,
    FieldsetModule,
    PrimeTemplate,
    NgFor,
    FormsModule,
    InputTextModule,
    CandidateDocumentDateComponent,
    AsyncPipe,
    EnumPipe,
    StaticDataPipe,
    AppDatePipe,
    DatepickerComponent,
  ],
})
export class FormlyCertifiedEducationExamsEntryComponent extends NewUiFormlyCertifiedEducationExamsEntryComponent {}
